// Import model
import { UpdateEstimateRequest } from '../models/UpdateEstimateRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateEstimateRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateEstimateRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateEstimateRequest instance
   */
  static deserialize(json: string): UpdateEstimateRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateEstimateRequest instance
   */
  static fromObject(obj: any): UpdateEstimateRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateEstimateRequest');
    }


    const instance: UpdateEstimateRequest = {
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      summary: obj['summary'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateEstimateRequest instances
   */
  static deserializeArray(json: string): UpdateEstimateRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateEstimateRequest instance to a JSON string
   */
  static serialize(instance: UpdateEstimateRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateEstimateRequest instance to a plain object
   */
  static toObject(instance: UpdateEstimateRequest): any {
    return {
      'name': instance.name,
      'description': instance.description,
      'summary': instance.summary,
    };
  }

  /**
   * Serializes an array of UpdateEstimateRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateEstimateRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
